import { useMutation, useQueryClient } from '@tanstack/react-query';

import { PREDEFINED_MESSAGE_CATEGORIES_QUERY_KEY } from '@/hooks/api/use-category-queries';
import { PREDEFINED_MESSAGES_QUERY_KEY } from '@/hooks/api/use-predefined-message-queries';
import httpClient from '@/lib/axios-instance';
import { API_ROUTES } from '@/lib/routes/api-routes';

async function deleteCategory(id: number) {
  await httpClient.delete(API_ROUTES.predefinedMessageCategories.detail(id));
}

export function useDeleteCategoryMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCategory,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PREDEFINED_MESSAGE_CATEGORIES_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: PREDEFINED_MESSAGES_QUERY_KEY });
    },
  });
}
